import { render } from "./AppHero.vue?vue&type=template&id=088e2cd5&scoped=true"
import script from "./AppHero.vue?vue&type=script&lang=js"
export * from "./AppHero.vue?vue&type=script&lang=js"

import "./AppHero.vue?vue&type=style&index=0&id=088e2cd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088e2cd5"]])

export default __exports__